export const DeadlineConfig: { label: string; value: number | string }[] = [
  {
    label: 'Trade.never',
    value: 'never',
  },
  {
    label: 'Trade.10min',
    value: 10 * 60,
  },
  {
    label: 'Trade.1hour',
    value: 60 * 60,
  },
  {
    label: 'Trade.1day',
    value: 24 * 60 * 60,
  },
  {
    label: 'Trade.3day',
    value: 3 * 24 * 60 * 60,
  },
  {
    label: 'Trade.7day',
    value: 7 * 24 * 60 * 60,
  },
  {
    label: 'Trade.30day',
    value: 30 * 24 * 60 * 60,
  },
];
